import { createFetch } from '@vueuse/core'
import { destr } from 'destr'
import { getAccessToken } from '@/plugins/auth/msalConfig'

const accessToken = useCookie('accessToken')
const userAbilityRules = useCookie('userAbilityRules')
const userData = useCookie<any>('userData')

export const useApi = createFetch({
  baseUrl: import.meta.env.VITE_API_BASE_URL || '/api',
  fetchOptions: {
    headers: {
      Accept: 'application/json',
    },
  },
  options: {
    refetch: true,

    async beforeFetch({ options }) {
      const msalToken = await getAccessToken()
      if (msalToken) {
        options.headers = {
          ...options.headers,
          Authorization: `Bearer ${msalToken}`,
        }
        return { options }
      } else {
        accessToken.value = null
        userAbilityRules.value = null
        userData.value = null
        window.location.href = '/login'
        return { options }
      }
    },

    afterFetch(ctx) {
      const { data, response } = ctx

      let parsedData = null
      try {
        parsedData = destr(data)
      } catch (error) {
        console.error(error)
      }

      return { data: parsedData, response }
    },

    onFetchError(ctx) {
      if (ctx.response?.status === 401) {
        accessToken.value = null
        userAbilityRules.value = null
        userData.value = null

        window.location.href = '/login'
      }

      return {
        ...ctx,
        data: ctx.data || ctx.error?.message || 'An error occurred',
      }
    },
  },
})
